import React, { useEffect, useRef, useState } from "react";
import EndPoint from "../../api/Endpoint";
import { redirect, useParams, useLocation } from "react-router-dom";
import UserNavbar from "../../components/NavBar/userNav.jsx";
import { useHttpClient } from "../../../src/hooks/HttpHook";
import _ from 'lodash'
import NoPDFModal from './no-pdf-modal';
import Loader from "../Loading/Loader";
import PdfUrlViewer from "../pdfjs/PdfUrlViewer.jsx";

const CategoryPage = (props) => {
    const location = useLocation()
    const categoryPdf = location.state.item;
    const [pdfcategories, setPDFCategories] = useState([]);
    const [curretPdfUrl, setCurrentPDF] = useState('');
    const [curretPdfUrlIndex, setCurrentPDFIndex] = useState(0);
    const [sortedPDF, setSortedPdf] = useState([]);
    const [nextBtn, setNextBtn] = useState(false);
    const [prevBtn, setPrevBtn] = useState(false);
    const { sendRequest } = useHttpClient();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [loading, setLoading] = useState(false);

    const [scale, setScale] = useState(1);
    const [page, setPage] = useState(1);
    const windowRef = useRef();

    useEffect(() => {
        if (localStorage.getItem('token') == null) {
            redirect(`${EndPoint.FRONT_LOGIN_URL}`);
        }
        sortTheUpcomingPDF();
    }, []);

    const sortTheUpcomingPDF = () => {
        const pdfArr = categoryPdf['pdfs'];
        if (!pdfArr || pdfArr?.length === 0) {
            setNextBtn(true);
            setPrevBtn(true);
            return;
        }
        let indexVal = 0;
        if (pdfArr.length > 1) {
            let valArr = pdfArr;
            valArr = _.orderBy(valArr, ['orderId'], ['asc']); // Use Lodash to sort array by 'name'
            valArr = valArr.filter(obj => Object.keys(obj).includes("orderId"));
            valArr.forEach((element, index) => {
                if (element.orderId >= 0 && indexVal === 0) {
                    console.log("############ valArr ###############", element, index);
                    indexVal = index;
                }
            });
            if (indexVal === 0) {
                let max = -Infinity;
                let keyIndex = 0;
                valArr.forEach((v, k) => {
                    if (v['orderId'] && max < +v['orderId']) {
                        max = +v['orderId'];
                        keyIndex = k;
                    }
                });
                indexVal = keyIndex;
            }
            setCurrentPDFIndex(indexVal);
            setSortedPdf(valArr);
            fetchURLOfPDF(valArr[indexVal], indexVal);
        } else {
            let valArr = pdfArr;
            // valArr = _.orderBy(valArr, ['orderId'],['asc']); // Use Lodash to sort array by 'name'
            valArr = valArr.filter(obj => Object.keys(obj).includes("orderId"));
            if (valArr.length > 0) {
                setCurrentPDFIndex(0);
                setSortedPdf(valArr);
                fetchURLOfPDF(valArr[0], 0);
            } else {
                setNextBtn(true);
                setPrevBtn(true);
            }
        }
    }

    const fetchURLOfPDF = async (sortedPDF, indexVal) => {
        try {
            setLoading(true);
            let pdfURL = sortedPDF.pdfUrl;
            disableNextPrevButtons(indexVal);
            const responseData = await sendRequest(
                EndPoint.BASE_URL_CATEGORY_FRONT_API + pdfURL,
                "GET",
            );
            setLoading(false);
            console.log("fetchURLOfPDF", responseData)
            setCurrentPDF(responseData.data);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    const disableNextPrevButtons = (indexVal) => {
        const pdfArr = categoryPdf['pdfs'];
        const valArr = pdfArr.filter(obj => Object.keys(obj).includes("orderId"));
        const pdfLength = valArr.length - 1;
        if (pdfLength === 0) {
            setNextBtn(true);
            setPrevBtn(true);
        } else if (indexVal === 0) {
            setPrevBtn(true);
            setNextBtn(false);
        } else if (pdfLength === indexVal) {
            setNextBtn(true);
            setPrevBtn(false);
        } else {
            setNextBtn(false);
            setPrevBtn(false);
        }
    }

    const changePageBack = () => {
        setLoading(true)
        if (prevBtn) {
            setShow(true);
            return;
        }
        const prevIndex = curretPdfUrlIndex - 1;
        setCurrentPDFIndex(prevIndex);
        fetchURLOfPDF(sortedPDF[prevIndex], prevIndex);
    }
    const changePagNext = () => {
        setLoading(true)
        if (nextBtn) {
            setShow(true);
            return;
        }
        const nextIndex = curretPdfUrlIndex + 1;
        setCurrentPDFIndex(nextIndex);
        fetchURLOfPDF(sortedPDF[nextIndex], nextIndex);
    }

    const handleOnLoad = () => {
        console.log("##### handleOnLoad #####")
        setLoading(false);
    }

    const scrollToItem = () => {
        windowRef.current && windowRef.current.scrollToItem(page - 1, "start");
    };

    const handleDownloadOld = async (url) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'file.pdf'; // or any name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed", error);
            alert("Something went wrong while downloading the file.");
        }
    };

    const handleDownload = async (url) => {
        try {
            // Extract the filename from the URL
            const urlObj = new URL(url);
            const pathname = urlObj.pathname; // gets everything before the "?"
            const fileName = pathname.substring(pathname.lastIndexOf('/') + 1);
    
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
    
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName || 'downloaded-file'; // fallback if no filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed", error);
        }
    };
    

    return (
        <>
            <UserNavbar />
            <section>
                <div className="container">
                    <div className="">
                        <div className="pdf-main-outer d-flex justify-content-between w-100">
                            <div className="left-side-btn">
                                {/* {pageNumber > 1 && */}
                                {/* <button className={prevBtn ? 'pre-btn disable':'pre-btn'} onClick={changePageBack} > */}
                                <button disabled={prevBtn} className={`pre-btn ${prevBtn ? 'disable' : ''}`} onClick={changePageBack}>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" height={11} width={6} fill='#fff' viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" /></svg>
                                    </span>
                                    Previous
                                </button>
                                {/* // } */}
                                {/* sdfs */}
                            </div>
                            <div className="center-title">{categoryPdf.title}</div>
                            <div className="right-side-button">
                                {/* { pageNumber < numPages && */}
                                {/* <button className={nextBtn?'next-btn disable':'next-btn'} onClick={changePagNext}> */}
                                <button disabled={nextBtn} className={`next-btn ${nextBtn ? 'disable' : ''}`} onClick={changePagNext}>
                                    NEXT
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" height={11} width={6} fill='#fff' viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" /></svg>
                                    </span>
                                </button>
                                {/* } */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="page-inner-cover">
                <div className="container">
                    {
                        sortedPDF.length == 0 ?
                            <div className="pdf-btn-outer">
                                No pdfs in selected category.
                            </div>
                            :
                            <div className="pdf-btn-outer">
                                {/* <iframe src="/pdf-sample.pdf#toolbar=0" height="735px" width="100%" controls={false} ></iframe > */}
                                {/* <iframe src={curretPdfUrl} height="735px" width="100%" onLoad={handleOnLoad} controls={false} ></iframe > */}
                                <div className="zoom-box">
                                    {/* <input value={page} onChange={e => setPage(e.target.value)} />
                                <button type="button" onClick={scrollToItem}>goto</button> */}

                                    <button type="button" title="Zoom-In" onClick={() => setScale(v => v + 0.2)}>+</button>
                                    <button type="button" title="Zoom-Out" onClick={() => setScale(v => v - 0.2)}>-</button>
                                    <span onClick={() => handleDownload(curretPdfUrl)} className="zoom-download" title="Download">
                                        {/* <svg width={18} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.
                                    8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" fill=""/></svg> */}
                                        <svg width="18" height="18" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_3267_1367)">
                                                <path d="M398.222 512H113.777C83.3883 512 54.8165 500.165 33.3253 478.674C11.8351 457.185 0 428.613 0 398.222V369.776C0 354.066 12.7343 341.33 28.4446 341.33C44.1549 341.33 56.8892 354.066 56.8892 369.776V398.222C56.8892 413.417 62.8073 427.702 73.5504 438.447C84.2965 449.192 98.5819 455.111 113.777 455.111H398.222C413.416 455.111 427.701 449.192 438.447 438.447C449.192 427.701 455.111 413.415 455.111 398.222V369.776C455.111 354.066 467.845 341.33 483.554 341.33C499.264 341.33 512 354.066 512 369.776V398.222C512 428.611 500.165 457.181 478.674 478.674C457.182 500.165 428.611 512 398.222 512ZM255.999 398.221C252.065 398.221 248.319 397.422 244.911 395.978C241.731 394.635 238.743 392.683 236.129 390.13C236.128 390.129 236.128 390.128 236.127 390.128C236.108 390.111 236.089 390.092 236.07 390.073C236.065 390.069 236.059 390.062 236.054 390.057C236.038 390.043 236.025 390.028 236.01 390.013C236 390.003 235.991 389.995 235.981 389.984C235.971 389.974 235.958 389.962 235.949 389.954C235.929 389.934 235.907 389.912 235.887 389.892L122.109 276.113C111.001 265.005 111.001 246.994 122.109 235.885C133.217 224.778 151.228 224.777 162.336 235.885L227.556 301.105V28.4446C227.555 12.7343 240.289 0 255.999 0C271.71 0 284.445 12.7343 284.445 28.4446V301.104L349.664 235.885C360.771 224.778 378.784 224.778 389.891 235.885C400.999 246.993 400.999 265.005 389.891 276.113L276.113 389.89C276.093 389.91 276.071 389.932 276.051 389.952C276.04 389.961 276.028 389.974 276.019 389.982C276.009 389.993 276 390.001 275.99 390.011C275.976 390.027 275.96 390.041 275.947 390.055C275.942 390.06 275.935 390.067 275.93 390.071C275.912 390.09 275.893 390.109 275.874 390.126C275.873 390.126 275.873 390.127 275.872 390.128C275.559 390.433 275.242 390.73 274.918 391.018C272.536 393.142 269.883 394.798 267.078 395.981C267.068 395.985 267.061 395.989 267.051 395.993C267.04 395.997 267.031 396.003 267.02 396.006C263.63 397.434 259.907 398.221 255.999 398.221Z" fill="white" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3267_1367">
                                                    <rect width="512" height="512" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>

                                    </span>
                                </div>

                                <div className="pdfjsBorder">
                                    {loading ? "Please Wait ..." : <PdfUrlViewer height="735px" width="100%" url={curretPdfUrl} scale={scale} windowRef={windowRef} />}

                                </div>
                            </div>
                    }


                </div>
                {loading ? (
                    <Loader />
                ) : null}
            </section>
            <NoPDFModal showModal={show} handleClose={handleClose} data='' />
        </>
    );
};
export default CategoryPage;